import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { StateModel } from 'src/models/regions/state';
import { API_url } from '../api.setup';

const API_Controller = '/states';
export const StateService = {
  getAllState: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as StateModel[];
    } catch (error) {
      throw error;
    }
  },

  addState: async (stateToUpdate: StateModel) => {
    try {
      const reqModel = {
        Name: stateToUpdate.name,
        Status: stateToUpdate.status,
        CountryId: stateToUpdate.country.id
      };

      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      return response.data as StateModel;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  deleteState: async (StateId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${StateId}`
      );

      return response.data as StateModel;
    } catch (error) {
      throw error;
    }
  },

  editState: async (editedData: StateModel) => {
    try {
      const reqModel = {
        Id: editedData.id,
        Name: editedData.name,
        Status: editedData.status,
        CountryId: editedData.country.id
      };
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        reqModel
      );

      const updatedState = {
        ...response.data,
        country: editedData.country
      };

      return updatedState as StateModel;
    } catch (error) {
      throw error;
    }
  }
};
